import { SofaButton } from '@sofology/sofologycomponents';
import { AddUpsellOptionModel } from 'models/Basket';
import React, { Component } from 'react';
import { UpsellContentItem } from '../BasketUpsellAccordion/upsellContentItems';
import './BasketUpsellToggler.scss';

interface OwnProps {
    options: AddUpsellOptionModel[];
    content: any;
    selectedOption: AddUpsellOptionModel | null;
    handleSelectToggleChange: any;
}

interface OwnState {

}

class BasketUpsellToggler extends Component<OwnProps, OwnState> {
    handleClick = (amount: number): ((e: React.MouseEvent) => void) => (e: React.MouseEvent): void => {
        e.stopPropagation();
        this.props.handleSelectToggleChange(amount);
    };

    render(): JSX.Element {
        const optionValues = this.props.options;

        return (
            <div className='basket-upsell-toggler'>
                <div className='basket-upsell-toggler__quantity'>
                    {optionValues.length > 0 && optionValues.map(option => this.renderButton(option, this.props.content))}
                </div>
            </div>
        );
    }

    renderButton(option: AddUpsellOptionModel, content: UpsellContentItem): JSX.Element {
        const description = content.togglerDescription ? content.togglerDescription(option.quantity) : undefined;
        const shouldRenderActive = this.props.selectedOption!.quantity === option.quantity;
        const upsellButtonText =
            <>
                <div className={'basket-upsell-toggler__button__title'}>{description}</div>
                <div className={'basket-upsell-toggler__button__price'}>£{option.price}</div>
            </>;

        return (
            <div className='basket-upsell-toggler__button' key={description}>
                <SofaButton
                    text={upsellButtonText}
                    variant='choice'
                    active={shouldRenderActive}
                    onClick={this.handleClick(option.quantity)}
                >
                </SofaButton>
            </div>
        );
    }
}

export default BasketUpsellToggler;